import AppModal from "./AppModal";
import AppModalHead from "./AppModalHead";
import AppModalContent from "./AppModalContent";

export { 
    AppModal,
    AppModalHead,
    AppModalContent,
 };